import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useAccountUsers } from 'hooks/Account/useAccountUsers';
import { useCurrentUser } from 'hooks/common/useCurrentUser';
import { useAccountByID } from 'hooks/Account/useAccountByID';
import { useMarketplaceAccount } from 'hooks/Marketplace/useMarketPlaceAccount';
import MarketPlaceHeaderSkeleton from 'sharedComponents/Skeleton/MarketPlaceHeaderSkeleton';
import { useStripeAccountStatusTypes } from 'hooks/EntityTypes/useStripeAccountStatusTypes';
import { useResize, useWorkspaceContext } from 'hooks/common';

import NoMarketPlaceAccount from './NoMarketPlaceAccount';

import AccountStatusSection from './AccountStatusSection';
import SparkTabs from 'sharedComponents/UI/SparkTabs';
import InfoTabContent from './InfoTabContent';
import SparksTabContent from './SparksTabContent';
import SparkRunsTabContent from './SparkRunsTabContent';

function Marketplace() {
  const { currentUserID } = useCurrentUser();
  const { isMobile } = useResize();
  const { getWorkspace } = useWorkspaceContext();
  const workspace = getWorkspace();
  const { accountIDbyUserIdMap, isLoading: isLoadingAccountUser } =
    useAccountUsers(workspace?.attributes.accountID);
  const { account, isLoading: isLoadingAccount } = useAccountByID(
    accountIDbyUserIdMap?.[currentUserID || '']
  );
  const { marketplaceAccounts, isLoading: isLoadingMarketplace } =
    useMarketplaceAccount(account?.id);
  const {
    stripeAccountStatusTypesIdMap,
    isLoading: isLoadingStripeAccountStatusTypes,
  } = useStripeAccountStatusTypes();

  const marketplaceAccount = marketplaceAccounts?.[0];
  const stripeAccountStatus =
    stripeAccountStatusTypesIdMap?.[
      marketplaceAccount?.attributes.stripeAccountStatusTypeID || ''
    ];

  const isLoading =
    isLoadingAccount ||
    isLoadingAccountUser ||
    isLoadingMarketplace ||
    isLoadingStripeAccountStatusTypes;
  if (isLoading) {
    return (
      <Box width='100%'>
        <MarketPlaceHeaderSkeleton />
      </Box>
    );
  }

  const tabItems = [
    {
      label: 'Profile',
      content: (
        <InfoTabContent
          stripeAccountStatus={stripeAccountStatus}
          marketplaceAccount={marketplaceAccount}
        />
      ),
    },
    {
      label: 'Sparks',
      content: <SparksTabContent marketplaceAccount={marketplaceAccount} />,
    },
    {
      label: 'Spark Runs',
      content: <SparkRunsTabContent />,
    },
  ];

  return (
    <Grid container padding={isMobile ? 2 : 3}>
      <Box
        display='flex'
        align-items='center'
        justifyContent='space-between'
        marginBottom={2}
      >
        <Typography
          variant='h4'
          sx={{
            color: '#404040',
            fontFamily: 'Mont-semibold',
          }}
        >
          Creator Profile
        </Typography>
      </Box>
      <Grid item xs={12}>
        {!!marketplaceAccount ? (
          <>
            <Grid container item justifyContent='space-between' gap={2} mb={4}>
              <AccountStatusSection status={stripeAccountStatus} />
            </Grid>

            <Grid item xs={12} mt={2}>
              <SparkTabs tabItems={tabItems} />
            </Grid>
          </>
        ) : (
          <>
            <NoMarketPlaceAccount />
          </>
        )}
      </Grid>
    </Grid>
  );
}

export default Marketplace;
